import { createContext } from 'react';
var PopoverContext = /*#__PURE__*/createContext(undefined);
export { PopoverContext as P };